import { defineMessages } from 'react-intl'

export default defineMessages({
  Term: {
    id: 'components.TermsAndPrivacy.Term',
    defaultMessage: 'Term',
    description: '请修改',
  },
  Privacy: {
    id: 'components.TermsAndPrivacy.Privacy',
    defaultMessage: 'Privacy',
    description: '请修改',
  },
  PoweredBy: {
    id: 'components.TermsAndPrivacy.PoweredBy',
    defaultMessage: 'Powered by',
    description: '请修改',
  },
})
